import {toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import CustomToastContainer from '../components/CustomToastContainer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { faLock, faEye, faEyeSlash, } from '@fortawesome/free-solid-svg-icons';
import lock from '../assets/ic--baseline-phonelink-lock.png';
import { resetPassword } from '../apiServices/apiServices.js';

export default function ResetPassword() {
    const location = useLocation();
    const navigate = useNavigate();
    const data = location.state;  
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] = useState(false);

    useEffect(() => {
        // console.log("Data State", data);
    }, []);
    

    const togglePasswordVisibility = () => {
        setIsPasswordVisible(!isPasswordVisible);
    };
    const toggleConfirmPasswordVisibility = () => {
    setIsConfirmPasswordVisible(!isConfirmPasswordVisible);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        if(password !== confirmPassword){
          toast.error('Passwords do not match.');
          return;
        }
        try {
            // console.log("Passenger Id ",data.id);
            const response = await resetPassword(data.id, password );
            // console.log("Response : ", response);
            if (response && response.success) {
              navigate('/login');
            } else {
              toast.error(response.message || 'Request failed');
            }
          } catch (error) {
            console.error('Error:', error);
            toast.error('An error occurred. Please try again.');
          }
    };

    return(
        <>
            <div className="bg-gray-100 flex flex-col items-center justify-center h-screen p-4 md:p-10">
                <div className="w-full md:w-1/2 py-10 md:py-20">
                    <div className="mb-10">
                        <div className="mx-auto text-center w-28">
                            <img src={lock} className="h-24 w-24 mb-2 mx-auto" alt="Logo" />
                            <p className="text-gray-600 font-semibold text-lg">
                                Reset Password
                            </p>
                        </div>
                    </div>
                    <div className="flex justify-center mt-5">
                        <form className="w-full sm:w-3/4 md:w-1/2" id="myForm" onSubmit={handleSubmit}>
                            <div className="mb-6 md:mb-8">
                                <div className="relative z-0 w-full mb-6 group">
                                    <FontAwesomeIcon icon={faLock} className="absolute text-[#BE1F18] left-0 top-3" />
                                    <input
                                        type={isPasswordVisible ? "text" : "password"}
                                        name="password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        id="floating_password"
                                        className="block py-2.5 pl-8 w-full text-sm text-[#BE1F18] bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#BE1F18] peer"
                                        placeholder=" "
                                        required
                                    />
                                    <label
                                        htmlFor="floating_password"
                                        className="peer-focus:font-medium absolute left-8 text-sm text-[#BE1F18] duration-300 transform -translate-y-6 scale-75 top-3 origin-[0] peer-focus:left-8 peer-focus:text-[#BE1F18] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                                    >
                                    Password
                                    </label>
                                    <FontAwesomeIcon
                                        icon={isPasswordVisible ? faEyeSlash : faEye}
                                        onClick={togglePasswordVisibility}
                                        className="absolute text-[#BE1F18] right-0 top-3 cursor-pointer"
                                    />
                                </div>
                                <div className="relative z-0 w-full mb-6 group mt-2">
                                    <FontAwesomeIcon icon={faLock} className="absolute text-[#BE1F18] left-0 top-3" />
                                    <input
                                        type={isConfirmPasswordVisible ? "text" : "password"}
                                        name="confirmPassword"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        id="floating_confirm_password"
                                        className="block py-2.5 pl-8 w-full text-sm text-[#BE1F18] bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-[#BE1F18] peer"
                                        placeholder=" "
                                        required
                                    />
                                    <label
                                        htmlFor="floating_confirm_password"
                                        className="peer-focus:font-medium absolute left-8 text-sm text-[#BE1F18] duration-300 transform -translate-y-6 scale-75 top-3 origin-[0] peer-focus:left-8 peer-focus:text-[#BE1F18] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                                    >
                                    Confirm Password
                                    </label>
                                    <FontAwesomeIcon
                                        icon={isConfirmPasswordVisible ? faEyeSlash : faEye}
                                        onClick={toggleConfirmPasswordVisibility}
                                        className="absolute text-[#BE1F18] right-0 top-3 cursor-pointer"
                                    />
                                </div>
                            </div>
                            <button
                                type="submit"
                                className="bg-[#BE1F18] text-white hover:bg-opacity-90 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm w-full px-5 py-2.5 text-center mt-5"
                            >
                                Submit
                            </button>
                        </form>
                    </div>
                </div>
            </div>
            <CustomToastContainer/>
        </>
    )
}